{
  "SHARED": {
    "EMAIL": "Email",
    "PHONE": "Phone",
    "NO_RESULTS": "No Results",
    "PREFERRED_CONTACT": {
      "HELP_TEXT_SMS": "Select how the participant will recieve notifications",
      "FIELD_NAME": "Preferred Contact",
      "SMS": "SMS",
      "EMAIL": "Email",
      "SMS_NOT_VERIFIED_WARNING": "Mobile number unverified",
      "SMS_NOT_VERIFIED_WARNING_DESC": "Notifications will continue to be sent via email until mobile number is verified",
      "EMAIL_NOT_VERIFIED_WARNING": "Email unverified",
      "RESEND_SMS": "Resend verification SMS",
      "RESEND_EMAIL": "Resend verification Email",
      "SEND_VERIFICATION_SUCCESS": "Verification code sent successfully"
    },
    "ERROR": {
      "FIELD_REQUIRED": "This field is required",
      "GENERIC": "An error occurred",
      "FORM_INVALID": "Please fill out all the required field(s)",
      "SERVER_500": "Server Error - If this continues please contact a member of GalaBid"
    },
    "FORMS": {
      "ERROR": {
        "MIN": "Must be at least {{min}}",
        "MAX": "Must be no more than {{max}}"
      }
    },
    "MAINTENANCE": {
      "TITLE": "We are currently performing scheduled maintenance.",
      "MESSAGE": "We hope to be back online very soon. Thank you for your patience and we apologise for any inconvenience caused."
    },
    "OFFLINE_SNACKBAR": {
      "NO_INTERNET_CONNECTION": "No Internet Connection",
      "TRY_AGAIN": "Try Again"
    },
    "USERS": {
      "ADD_PAYMENT_METHOD_VERIFICATION_ERROR": "Guest must be verified to add a payment method",
      "ADD_PAYMENT_METHOD_EMAIL_ERROR": "An email address is required to add a payment method to this guest's account",
      "NO_STRIPE_CUSTOMER": "No Stripe customer"
    },
    "PADDLE_NUMBER": {
      "ASSIGN": "Assign",
      "ASSIGN_DIALOG": {
        "TITLE": "Assign Paddle Number {{paddleNumber}} ",
        "SEARCH": "Search profiles",
        "SELECT_AND_RETRY": "Please select a profile and try again",
        "ALREADY_PADDLE_NUMBER": "Guest has already been assigned paddle number {{paddleNumber}}, please select a guest without a paddle number",
        "NO_NAME": "No Name",
        "ASSIGN": "Assign",
        "CANCEL": "Cancel",
        "PADDLE_NUMBER": "Paddle Number: {{paddleNumber}}",
        "ASSIGNMENT_SUCCESS": "Paddle number assigned successfully",
        "ASSIGNMENT_FAILURE": "Failed to assign paddle number"
      },
      "PLEDGES_ADDED": "{{numPledges}} Pledges Added ({{value}}) ",
      "PLEDGE_INPUT": "Add Pledges",
      "PLEDGE_LIST": "Pledge List",
      "PADDLE_RAISE": "Paddle Raise",
      "GIVING_LEVEL_TITLE": "Giving Level",
      "GIVING_LEVELS": "Giving Levels",
      "GIVING_LEVELS_DESC": "Select a giving level to start adding pledges",
      "PADDLE_RAISE_PLEDGES": "Paddle Raise Pledges",
      "PROFILE_UNVERIFIED": "Paddle number can only be added once the profile is verified",
      "PROFILE_UNVERIFIED_EMAIL": "Paddle number can only be added once the profile has verified their email",
      "PROFILE_UNVERIFIED_PHONE": "Paddle number can only be added once the profile has verified their phone number",
      "PROFILE_UNVERIFIED_PAYMENT_METHOD": "Paddle number can only be added once the profile is verified and a payment method is linked",
      "PROFILE_UNVERIFIED_EMAIL_PAYMENT_METHOD": "Paddle number can only be added once the profile has verified their email and a payment method is linked",
      "PROFILE_UNVERIFIED_PHONE_PAYMENT_METHOD": "Paddle number can only be added once the profile has verified their phone number and a payment method is linked",
      "PROFILE_NO_PAYMENT_METHOD": "Paddle number can only be added once payment method is linked",
      "PADDLE_NUMBER": "Paddle Number",
      "AUTO_SELECT_PADDLE_NUMBER": "Auto-select Paddle Number",
      "PADDLE_TAKEN": "This paddle number is already in use",
      "PADDLE_AVAILABLE": "This paddle number is available ",
      "GIVING_LEVEL": {
        "NO_GIVING_LEVELS": "No giving levels",
        "NO_GIVING_LEVELS_VOLUNTEER": "No giving levels have been added - Please contact the campaign admin",
        "ADD_GIVING_LEVEL": "Add a giving level to get started",
        "ADD_PLEDGES": "Add Pledges",
        "EDIT": "Edit",
        "DELETE": "Delete",
        "DELETED": "Giving Level Deleted",
        "UPDATED": "Giving Level Updated",
        "CREATED": "Giving Level Created",
        "NEXT": "Next - {{value}}",
        "PREVIOUS": "Previous - {{value}}"
      },
      "TITLE": "Paddle Raise - {{value}} ",
      "RAISED": "Raised:",
      "ENTER_MULTIPLE_PADDLE_NUMBERS_HINT": "Enter a comma or space-separated list to add multiple pledges at once",
      "ENTER_PADDLE_NUMBER": "Enter Paddle Number",
      "ADD": "Add",
      "PADDLES_ADDED_SUCCESS": "Paddle numbers added successfully",
      "PADDLES_ADDED_SUCCESS_DESCRIPTION": "These paddles are linked to guests with complete accounts.",
      "PADDLES_ADDED_NO_PROFILE": "Paddle numbers not linked to profiles",
      "PADDLES_ADDED_FAILURE_DESCRIPTION": "These paddles do not have a corresponding guest and will need to be amended in order to take payment. Either add these paddles to an existing guest, or delete below and add a new paddle number. ",
      "PADDLES_ADDED_INCOMPLETE": "Paddle numbers linked to incomplete profiles",
      "PADDLES_ADDED_INCOMPLETE_DESCRIPTION": "These paddle numbers are linked to guest with incomplete or unverified profiles.",
      "NO_PLEDGES": "No paddles added yet",
      "VIEW_GUEST_DETAILS": "View guest details",
      "GUEST_DETAILS_DIALOG": {
        "TITLE": "Guest Details",
        "TABLE": "Table"
      },
      "PADDLE_VALIDATION_ERROR": "Paddle number must be between {{min}} and {{max}}",
      "PADDLES_ALREADY_ADDED": "Paddles already added - {{paddles}}",
      "INVALID_PADDLES": "Invalid paddles - {{paddles}}",
      "PLEDGE_DELETED": "Pledge Deleted",
      "DELETE_DIALOG": {
        "NO_PROFILE_LINKED": "No profile linked",
        "TITLE": "Delete Pledge",
        "DESC": "Are you sure you would like to delete this pledge",
        "DELETE": "Delete",
        "CANCEL": "Cancel",
        "NO_DETAILS": "No guest details"
      }
    },
    "PAYMENT_METHOD_CHIP": {
      "CONNECTED_SLIM": "Connected",
      "NOT_CONNECTED_SLIM": "Not connected",
      "CONNECTED": "Payment method connected",
      "NOT_CONNECTED": "Payment method not connected"
    },
    "EVENT_TICKETS": {
      "STATUS": {
        "ACCEPTED": "Accepted",
        "ACCEPTED_INFO": "Guest has confirmed their attendance",
        "CHECKED_IN": "Checked In",
        "CHECKED_IN_INFO": "Guest has arrived at the venue and checked in",
        "DECLINED": "Declined",
        "DECLINED_INFO": "Guest declined and ticket awaiting transfer",
        "AWAITING_ACCEPTANCE": "Awaiting Acceptance",
        "INVITE_SENT": "Invite Sent",
        "INVITE_SENT_INFO": "Guest received but not yet accepted invite",
        "UNASSIGNED": "Unassigned",
        "UNASSIGNED_INFO": "Ticket not yet assigned to any guest"
      },
      "FILTER": {
        "SORT_LABEL": "Sort by",
        "STATUS_LABEL": "Status",
        "GUEST_LABEL": "Guest",
        "PURCHASER_LABEL": "Purchaser",
        "TICKET_LABEL": "Ticket Name"
      },
      "CHECK_IN": {
        "HEADER": "Event Check In",
        "GUEST_LIST_HEADER": "Guest List",
        "EXPAND_ALL": "Expand All",
        "COLLAPSE_ALL": "Collapse All",
        "SEARCH": "Search Guests",
        "EMPTY_STATE": "No guests found",
        "SUMMARY": "Summary",
        "SUMMARY_HEADER": "Guest Summary",
        "CHECKED_IN_RATIO": "({{checkedInCount}}/{{totalCount}} Checked In)",
        "TICKET_NOT_ASSIGNED": "Ticket not assigned",
        "GUEST_OF_PURCHASER": "(Guest of {{name}})",
        "REGISTERED_LABEL": "Registered",
        "QUESTIONS_COMPLETE": "Ticketing questions complete",
        "QUESTIONS_INCOMPLETE": "Ticketing questions incomplete",
        "READY_TO_BID": "Ready to bid / buy / donate",
        "NOT_READY_TO_BID": "Not ready to bid / buy / donate",
        "TICKET_GUEST_COMPLETE": "Ticketing profile complete",
        "PURCHASER_LABEL": "Purchaser",
        "TABLE": "Table",
        "NOTIFICATION_DELIVERY": "Notification Delivery",
        "PADDLE_NUMBER": "Paddle Number",
        "TICKET_NUMBER_LABEL": "Ticket Number",
        "CHECK_IN_BUTTON_LABEL": "Check In",
        "PAYMENT_METHOD_WARNING": "Your guest must set up a payment method before they can be checked in",
        "UNDO_CHECK_IN_BUTTON_LABEL": "Undo Check In",
        "ERROR_TOAST_CHECK_IN": "Guest has been deleted and cannot be checked in",
        "SUCCESS_TOAST_CHECK_IN": "Guest Checked In Successfully",
        "SUCCESS_TOAST_CHECK_OUT": "Guest Checked Out Successfully",
        "SCANNER": {
          "HEADER": "QR Code Check In",
          "CAMERA_PROMPT_HEADER": "Camera Access Required",
          "CAMERA_PROMPT_DESCRIPTION": "Please allow camera permissions when prompted.",
          "CAMERA_DENIED": "Camera Access Denied",
          "CAMERA_DENIED_DESCRIPTION": "Please update your settings and reload.",
          "DENIED_ERROR": "You need to allow camera access to use this feature",
          "START_INFO": "To start scanning tickets, select the <strong>Start</strong> button. Make sure your guests have their QR code ready from the ticket PDF they received.",
          "START_BUTTON": "Start",
          "CHECK_IN_SUCCESS_HEADER": "Guest Checked In",
          "CHECK_IN_FAILED_HEADER": "Check In Failed",
          "CHECK_IN_FAILED_INFO": "Guest already checked in by <strong>{{name}}</strong>.",
          "NAME_LABEL": "Guest",
          "TABLE_NAME_LABEL": "Table name",
          "CHECK_IN_TIME_LABEL": "Check in time",
          "STATUS_LABEL": "Status",
          "CONTINUE_BUTTON": "Continue Scanning",
          "VIEW_HISTORY_LINK": "View my check in history",
          "NO_CHECK_INS_HEADER": "No Check In History",
          "NO_CHECK_INS": "You haven't checked any guests in yet. Once you start checking in guests, your history will appear here."
        }
      },
      "MORE_ACTIONS": {
        "PAYMENT_METHODS": "Payment methods",
        "TOOLTIP": "More Actions",
        "EDIT_GUEST": "Edit guest",
        "ASSIGN_TICKET": "Assign ticket",
        "RESEND_INVITE": "Resend invite",
        "RESEND_TICKET": "Resend ticket",
        "TRANSFER_TICKET": "Transfer ticket",
        "DECLINE_TICKET": "Decline ticket",
        "UNASSIGN_TICKET": "Unassign ticket",
        "VIEW_ITEM": "View purchased item"
      },
      "STEPPER": {
        "ASSIGNEE_STEP_LABEL": "Assignee",
        "QUESTIONS_STEP_LABEL": "Questions",
        "SKIP_TEXT": "Don't have guest details?"
      },
      "ASSIGN_TICKET": {
        "HEADER": "Assign Ticket",
        "DESCRIPTION": "Enter the details of the person to assign <strong>{{name}}</strong>",
        "ASSIGN_BUTTON": "Assign",
        "SUCCESS_TOAST": "Ticket Assigned Successfully",
        "SKIP_LINK": "Skip and assign"
      },
      "MULTI_ASSIGN": {
        "STEP_LABEL": "Assign",
        "HEADER": "Assign Tickets",
        "ORDER_CONFIRMED_HEADER": "Your order is confirmed",
        "ORDER_CONFIRMED_DESCRIPTION": "An order confirmation has been sent to your email. Optionally assign tickets below or complete later from My Account.",
        "ORDER_CONFIRMED_DESCRIPTION_ADMIN": "An order confirmation has been sent to the guest's email. Optionally assign tickets below, later in the 'Guests' section, or let the guest assign from their account.",
        "SKIP_LINK": "Skip and assign later"
      },
      "EDIT_GUEST": {
        "HEADER": "Edit Guest",
        "NO_TABLE_OPTION": "No Table",
        "CHECK_IN_HEADER": "Check In Guest",
        "CHECK_IN_INFO": "Please review {{name}}'s details prior to check in.",
        "CHECK_IN_BUTTON": "Check In",
        "SUCCESS_TOAST": "Guest Updated"
      },
      "CONFIRM": {
        "RESEND_INVITE_HEADER": "Resend Invite",
        "RESEND_TICKET_HEADER": "Resend Ticket",
        "RESEND_DESCRIPTION": "On Confirm, a ticket notification will be sent to <strong>{{email}}</strong>.",
        "UNASSIGNED_TICKETS_HEADER": "Ticket/s Still Need Assigning",
        "UNASSIGNED_TICKETS_DESCRIPTION": "You have one or more unassigned tickets. Tickets must be assigned in order to be issued. If you don't have your guests' details, you can skip now and complete later from 'My Account'.",
        "UNASSIGNED_TICKETS_DESCRIPTION_ADMIN": "You have one or more unassigned tickets. Tickets must be assigned in order to be issued. If you don't have your guests' details, you can skip now and complete later from the 'Guests' section or let the guest assign from their account.",
        "UNASSIGNED_TICKETS_CONFIRM_BUTTON": "Skip and assign later",
        "UNASSIGN_TICKETS_CANCEL_BUTTON": "Assign now",
        "UNASSIGN_TICKET_HEADER": "Unassign Ticket",
        "UNASSIGN_TICKET_DESCRIPTION": "On Confirm, <strong>{{guest}}</strong> will be removed from <strong>{{ticket}}</strong>. The ticket can then be reassigned to another guest.",
        "UNASSIGN_TICKET_SUCCESS_TOAST": "Ticket Unassigned Successfully"
      },
      "SEND_TICKET": {
        "SUCCESS_TOAST": "Email Sent Successfully"
      },
      "TRANSFER_TICKET": {
        "HEADER": "Transfer Ticket",
        "DESCRIPTION": "Enter the details of the person you would like to transfer the ticket to.",
        "ON_TRANSFER_INFO": "On transfer, the existing ticket for <strong>{{guest}}</strong> will be cancelled and a new ticket will be issued to the guest below.",
        "TRANSFER_BUTTON": "Transfer",
        "SUCCESS_TOAST": "Ticket Transferred Successfully",
        "SKIP_LINK": "Skip and transfer"
      },
      "FORM": {
        "ASSIGN_TO_ME": "Assign to me",
        "ASSIGN_TO_PURCHASER": "Assign to purchaser",
        "ASSIGN_ALL_TO_ME": "Assign all to me",
        "ASSIGN_ALL_TO_PURCHASER": "Assign all to purchaser",
        "EMAIL_MATCHES_ERROR": "Enter a different email to invite someone else",
        "EMAIL_MATCHES_ERROR_ASSIGN_TO_ME": " or check \"Assign to me\"",
        "EMAIL_MATCHES_ERROR_ASSIGN_TO_PURCHASER": " or check \"Assign to purchaser\"",
        "INVITE_EMAIL_INFO": "On {{buttonLabel}}, an invite will be sent to this email address.",
        "VERIFY_EMAIL_INFO": "Your guest will receive an email with a link to verify. They will need to click this link in order to complete registration.",
        "CHANGE_EMAIL_INFO": "Need to change email?",
        "CHANGE_EMAIL_LINK": "Transfer ticket",
        "FIRST_NAME": "First Name",
        "LAST_NAME": "Last Name",
        "EMAIL": "Email",
        "PHONE": "Phone Number",
        "TABLE": "Table Name",
        "NO_TABLE_OPTION": "No Table"
      }
    },
    "PAYMENT": {
      "LOADER_CONFIRM_CARD_PAYMENT": "Confirming payment",
      "PENDING": {
        "MESSAGE": "Please wait while we confirm your order",
        "DELAYED_MESSAGE": "We're still confirming your order, thank you for waiting",
        "EXPIRED_MESSAGE": "Your order cannot be confirmed at this time, please check back later.",
        "BUTTON_LABEL": "OK"
      },
      "EXPIRED": {
        "HEADER": "Payment Session Expired",
        "BODY": "Your payment session has expired, please start again.",
        "ACTION": "OK"
      }
    },
    "CARD_LIST": {
      "LOADING": "Loading cards",
      "EXPIRY_LABEL": "Expiry",
      "EXPIRED": "Expired",
      "DELETE_CARD": "Delete Card",
      "NO_CARDS_GUEST": "You have no cards saved! You can add one now if you wish to make payments.",
      "NO_CARDS_ADMIN_VOLUNTEER": "This guest has no cards saved! You can add one for them now to make payments."
    },
    "POWERED_BY_STRIPE": {
      "SECURE_PAYMENT_STRIPE": "Secure payments powered by"
    },
    "TIMER": {
      "TIME_REMAINING": "Time remaining:",
      "DAY": "Day",
      "DAYS": "Days",
      "HOUR": "Hour",
      "HOURS": "Hours",
      "MINUTE": "Minute",
      "MINUTES": "Minutes",
      "SECOND": "Second",
      "SECONDS": "Seconds"
    },
    "IMAGE_UPLOADER": {
      "MAX_HEIGHT": "Max Height",
      "MAX_WIDTH": "Max Width",
      "SELECT_IMAGE": "Select Image",
      "SELECT_IMAGES": "Select Images",
      "BROWSE": "Choose Image",
      "DRAG_AND_DROP_HERE": "Drop image here",
      "RECOMMENDED_SIZE": "{{width}}px wide x {{height}}px high",
      "DIMENSIONS_WARNING": "Image must be no larger than {{width}}px x {{height}}px",
      "FORMAT_ERROR": "Image must be one of the following formats: {{formats}}",
      "IMAGE_UPLOADING_DELAY": "Please wait for the image to finish uploading",
      "UPLOAD_FAILED": "Image upload failed, please try again",
      "ROTATE_LEFT": "Rotate Left",
      "ROTATE_RIGHT": "Rotate Right",
      "SKIP": "Skip",
      "NEXT": "Next",
      "DONE": "Done",
      "ENABLE_EDITOR": "Enable Editor"
    }
  }
}
